import solver from 'solver-utilities';

export const blockBanner = async function () {
	const backgroundImage = document.querySelector('[data-block-banner-background-image]');
	const foregroundLeft = document.querySelector('[data-block-banner-foreground-left]');
	const foregroundRight = document.querySelector('[data-block-banner-foreground-right]');
	const foregroundCenter = document.querySelector('[data-block-banner-foreground-center]');
	const text = document.querySelector('[data-block-banner-text]');
	const quote = document.querySelector('[data-block-banner-quote]');

	if (backgroundImage) {
		backgroundImage.classList.add('animate__fadeIn');
		await solver.each.asyncTimeout(500);
	}

	if (foregroundLeft) foregroundLeft.classList.add('animate__fadeIn');
	if (foregroundRight) foregroundRight.classList.add('animate__fadeIn');
	if (foregroundCenter) foregroundCenter.classList.add('animate__fadeIn');

	if (foregroundLeft || foregroundRight || foregroundCenter) await solver.each.asyncTimeout(500);

	if (text) text.classList.add('animate__zoomIn');
	if (quote) quote.classList.add('animate__zoomIn');
};
